import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { PollutionForecastTypes } from 'src/app/models/app-constants';

@Component({
	selector: 'app-forecast-key-widget',
	templateUrl: './forecast-key-widget.component.html',
	styleUrls: ['./forecast-key-widget.component.scss']
})
export class ForecastKeyWidgetComponent implements OnInit, OnChanges {
	@Input() pollutionForecast : string | undefined;
	@Input() description: string = "";
	
	pollLevelIndicatorIcon : string = "";
	pollLevelIndicatorText : string = ""

	ngOnInit(): void {

	}

	ngOnChanges(changes: SimpleChanges): void {
		if(changes["pollutionForecast"])
		{
			const forecast = changes["pollutionForecast"].currentValue;
			switch (forecast) {
				case PollutionForecastTypes.POLLUTION_LIKELY:					
					this.pollLevelIndicatorIcon = "Red.svg";
					this.pollLevelIndicatorText = this.pollutionForecast ?? "";
					break;
				case PollutionForecastTypes.POLLUTION_UNLIKELY:
					this.pollLevelIndicatorIcon = "Green.svg";
					this.pollLevelIndicatorText = this.pollutionForecast ?? ""
					break;
				case PollutionForecastTypes.POLLUTION_POSSIBLE:
					this.pollLevelIndicatorIcon = "Yellow.svg";
					this.pollLevelIndicatorText = this.pollutionForecast ?? ""
					break;
				default:
					this.pollLevelIndicatorIcon = "Unavailable.svg";
					this.pollLevelIndicatorText = this.pollutionForecast ?? ""
					break;
			}
		}	

	}
}
